import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasKindTarget) return
    const rent = this.currentKind() === "rent"
    document.querySelectorAll("[data-listing-rent-fields]").forEach((el) => {
      el.classList.toggle("hidden", !rent)
    })
    document.querySelectorAll("[data-listing-sale-fields]").forEach((el) => {
      el.classList.toggle("hidden", rent)
    })
    this.toggleUtilities()
  }

  toggleUtilities() {
    const rent = this.currentKind() === "rent"
    const included = document.querySelector('[name="pro_listing[utilities_included]"]')?.checked
    document.querySelectorAll("[data-listing-charges-field]").forEach((el) => {
      el.classList.toggle("hidden", rent && included)
    })
  }

  // `kind` may be a single <select> (its own .value is authoritative) or a
  // group of radio inputs sharing the same target name (Stimulus's singular
  // `kindTarget` would always return the first one, ignoring which is
  // actually checked) — pick the checked one when there's more than one.
  currentKind() {
    if (this.kindTargets.length > 1) {
      return this.kindTargets.find((el) => el.checked)?.value
    }
    return this.kindTarget.value
  }
}
